import UsageTracker from '../../../utils/UsageTracker';
export const trackViewAllClick = type => {
  UsageTracker.track('teamInteraction', {
    action: 'view-all-clicked',
    type
  });
};
export const trackAwardLinkClick = (certificationId, certificationName) => {
  UsageTracker.track('teamInteraction', {
    action: 'view-award-link-clicked',
    contentId: certificationId.toString(),
    contentName: certificationName
  });
};
export const trackExamLinkClick = (certificationId, certificationName) => {
  UsageTracker.track('teamInteraction', {
    action: 'view-exam-link-clicked',
    contentId: certificationId.toString(),
    contentName: certificationName
  });
};
export const trackCertificationStatusChange = newStatus => {
  UsageTracker.track('teamInteraction', {
    action: 'filter-selected',
    type: 'certification-status',
    value: newStatus
  });
};
export const trackDownloadCertificateClick = (certificationId, certificationName) => {
  UsageTracker.track('teamInteraction', {
    action: 'download-certificate-clicked',
    contentId: certificationId.toString(),
    contentName: certificationName
  });
};